export interface RemoveQueryParamFromURLParams {
  queryParamName: string | string[];
}

export const removeQueryParamsFromURL = ({
  queryParamName,
}: RemoveQueryParamFromURLParams) => {
  const url = new URL(window.location.href);

  const queryParamNames = Array.isArray(queryParamName)
    ? queryParamName
    : [queryParamName];

  queryParamNames.forEach(name => url.searchParams.delete(name));

  // using history api to prevent page refreshing; replaceState (not
  // pushState) so the removed params can't be restored via the back button.
  // preserve the existing history state — react-router keeps {usr, key, idx}
  // there, and passing {} would wipe location.state and corrupt the router's
  // history index
  window.history.replaceState(window.history.state, document.title, url);
};
